import React, { useCallback } from "react";

import { FormattedMessage } from "react-intl";
import { graphql, useMutation } from "react-relay";
import { IntegrationPushAppyCreateScreenMutation } from "./__generated__/IntegrationPushAppyCreateScreenMutation.graphql";
import { useAlert } from "../../common/Alert";

import { IntegrationActivateScreen } from "./components/IntegrationActivation";
import { IntegrationPushAppyScreenDeleteMutation } from "./__generated__/IntegrationPushAppyScreenDeleteMutation.graphql";

import { IntegrationSettings } from "./components/IntegrationSettings";
import { IntegrationLogo } from "./components/Logos/Logos";

export function IntegrationPushAppy(props: {
  onCompleted: () => void;
  mode: "create" | "edit";
}) {
  switch (props.mode) {
    case "create":
      return <PushAppyCreate onCompleted={props.onCompleted} />;
    case "edit":
      return <PushAppyEdit onCompleted={props.onCompleted} />;
  }
}
function PushAppyCreate({ onCompleted }: { onCompleted: () => void }) {
  const [value, setValue] = React.useState("");

  const isValid = value.trim().startsWith("https://tv.pushappy.com");

  const [create, loading] =
    useMutation<IntegrationPushAppyCreateScreenMutation>(graphql`
      mutation IntegrationPushAppyCreateScreenMutation($link: String!) {
        store {
          activateIntegrationPushAppy(link: $link)
        }
      }
    `);

  const Alert = useAlert();

  const onCreate = useCallback(() => {
    create({
      onCompleted: (d) => {
        if (d.store.activateIntegrationPushAppy) {
          onCompleted();
        } else {
          Alert.error(
            "Fel Uppstod",
            "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt länk eller kod "
          );
        }
      },
      variables: { link: value },
    });
  }, [Alert, create, onCompleted, value]);

  return (
    <IntegrationActivateScreen
      onActivate={onCreate}
      isActivating={loading}
      isValid={value.length > 0 && isValid}
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="pushappy" />}
        />
      }
      activation={
        <IntegrationActivateScreen.Input
          value={value}
          onChangeText={setValue}
          type="url"
          label={
            <FormattedMessage
              description="IntegrationsAdminPushAppy create screen instruction"
              defaultMessage="Paste a link to your pushappy-dashboard here"
            />
          }
        />
      }
    />
  );
}

function PushAppyEdit({ onCompleted }: { onCompleted: () => void }) {
  const [deleteIntegration, pending] =
    useMutation<IntegrationPushAppyScreenDeleteMutation>(graphql`
      mutation IntegrationPushAppyScreenDeleteMutation {
        store {
          deleteIntegrationPushAppy
        }
      }
    `);
  const requestDelete = useCallback(() => {
    deleteIntegration({
      variables: {},
      onCompleted,
    });
  }, [deleteIntegration, onCompleted]);

  return (
    <IntegrationSettings
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="pushappy" />}
        />
      }
      delete={{
        pending,
        requestDelete,
      }}
    />
  );
}
